import { messagesRu } from '../messages/messages-ru';

export const environment = {
  production: true,
  apiUrl: '/api/',
  recordsUrl: '/records/',
};

export const messages = messagesRu;



// WEBPACK FOOTER //
// ./src/environments/environment.ts